module.exports = __webpack_public_path__ + "img/IMG-20171022-WA0002.36630e85.jpg";